import React, {Component} from 'react';
// import {Link} from "react-router-dom";
import {connect} from 'react-redux';

import {withStyles} from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';
import IconButton from '@material-ui/core/IconButton';
import DeleteIcon from '@material-ui/icons/Delete';

import {deletePoll} from 'actions';

// export default function AlertDialogSlide() {
class DeleteButton extends Component {
  constructor(props) {
    super(props);
    this.state = {
      alertOpen: false,
    };
  }

  handleDeleteBtnClick(event) {
    event.stopPropagation();
    this.setState({alertOpen: true});
  }

  handleCancelDelete(event) {
    event.stopPropagation();
    this.setState({alertOpen: false});
  }

  handleDeletePoll(event) {
    const {deletePoll, pid} = this.props;
    event.stopPropagation();
    deletePoll(pid);
    this.setState({alertOpen: false});
    console.log('we deleted the shit out of you.');
  }

  render() {
    const {classes} = this.props;

    return (
      <div>
        <IconButton className={classes.icon}>
          <DeleteIcon onClick={e => this.handleDeleteBtnClick(e)}/>
        </IconButton>
        <Dialog
          open={this.state.alertOpen}
          onClose={() => this.setState({alertOpen: false})}
          maxWidth="xs"
          aria-labelledby="alert-dialog-delete-title"
          aria-describedby="alert-dialog-delete-description"
        >
          <DialogTitle id="alert-dialog-delete-title">{"Delete Poll?"}</DialogTitle>
          <DialogContent>
            <DialogContentText id="alert-dialog-delete-description">
              Are you absolutely 100% positively sure you want to delete this poll??
            </DialogContentText>
          </DialogContent>
          <DialogActions>
            <Button onClick={e => this.handleCancelDelete(e)} color="primary">
              Cancel
            </Button>
            <Button onClick={e => this.handleDeletePoll(e)} color="primary">
              Delete
            </Button>
          </DialogActions>
        </Dialog>
      </div>
    );
  }
}

// const pageWithStyles = withStyles(styles)(DeleteButton);

const styles = theme => ({
  icon: {
    color: 'rgba(255, 255, 255, 0.54)',
    "&:hover": {
      color: "#9c27b0",
    },
  },
});

export default connect(null, {deletePoll})(withStyles(styles)(DeleteButton));



// WEBPACK FOOTER //
// ./src/components/Alerts/DeletePoll.jsx